import {appendQueryString} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IPaginatedResponse} from "../../request/IPaginatedResponse";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IGetOfferListPayload} from "../types/GetOfferListPayload";
import {IOfferListMapOffer} from "../types/IOfferListMapOffer";

const OFFER_LIST_MAP_PAGE_SIZE = 1000;
const offerListMapLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST_MAP);

export interface IMapOfferListResponse {
    offers: IOfferListMapOffer[];
    count: number;
    page_size: number;
}

export interface IMapOfferListPayload extends IGetOfferListPayload {
    country?: string;
}

export const getMapOfferList = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getMapOfferList: build.query<IPaginatedResponse<IOfferListMapOffer>, IGetOfferListPayload>({
            query: (params) => ({
                url: offerListMapLink,
                params
            })
        }),
        getFullMapOfferList: build.query<IMapOfferListResponse, IMapOfferListPayload>({
            queryFn: async (params, _api, _extraOptions, baseQuery) => {
                try {
                    const initialQuery = {...params, page_size: 0};
                    const initialUrl = appendQueryString(offerListMapLink, initialQuery);
                    const initialResponse = await baseQuery({
                        url: initialUrl
                    });

                    if (initialResponse.error) {
                        return {error: getIgnoredNotifyResponse(initialResponse.error, [400, 404])};
                    }

                    const initialData = initialResponse.data as IPaginatedResponse<IOfferListMapOffer>;
                    const totalCount = initialData.count;
                    const pages = Math.ceil(totalCount / OFFER_LIST_MAP_PAGE_SIZE);

                    // Prepare paginated queries
                    const pagePromises = Array.from({length: pages}, (_, index) => {
                        const pageQuery = {...params, page_size: OFFER_LIST_MAP_PAGE_SIZE, page: index + 1};
                        const pageUrl = appendQueryString(offerListMapLink, pageQuery);
                        return baseQuery({url: pageUrl});
                    });

                    const pageResponses = await Promise.all(pagePromises);

                    const errorResponse = pageResponses.find((response) => response.error);
                    if (errorResponse) {
                        return {error: getIgnoredNotifyResponse(errorResponse.error!, [400, 404])};
                    }

                    // Concatenate all offers from all pages
                    const allOffers: IOfferListMapOffer[] = [];
                    pageResponses.forEach((response) => {
                        const pageData = response.data as IPaginatedResponse<IOfferListMapOffer>;
                        allOffers.push(...pageData.results);
                    });

                    return {
                        data: {
                            offers: allOffers,
                            count: totalCount,
                            page_size: OFFER_LIST_MAP_PAGE_SIZE
                        }
                    };
                } catch {
                    return {
                        error: {
                            status: "CUSTOM_ERROR",
                            error: "Failed to fetch full map offer list"
                        }
                    };
                }
            }
        })
    })
});

export const {useGetFullMapOfferListQuery} = getMapOfferList;
import {appendQueryString} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IPaginatedResponse} from "../../request/IPaginatedResponse";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IGetOfferListPayload} from "../types/GetOfferListPayload";
import {IOfferListMapOffer} from "../types/IOfferListMapOffer";

const OFFER_LIST_MAP_PAGE_SIZE = 1000;
const offerListMapLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST_MAP);

export interface IMapOfferListResponse {
    offers: IOfferListMapOffer[];
    count: number;
    page_size: number;
}

export interface IMapOfferListPayload extends IGetOfferListPayload {
    country?: string;
}

export const getMapOfferList = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getMapOfferList: build.query<IPaginatedResponse<IOfferListMapOffer>, IGetOfferListPayload>({
            query: (params) => ({
                url: offerListMapLink,
                params
            })
        }),
        getFullMapOfferList: build.query<IMapOfferListResponse, IMapOfferListPayload>({
            queryFn: async (params, _api, _extraOptions, baseQuery) => {
                try {
                    const initialQuery = {...params, page_size: 0};
                    const initialUrl = appendQueryString(offerListMapLink, initialQuery);
                    const initialResponse = await baseQuery({
                        url: initialUrl
                    });

                    if (initialResponse.error) {
                        return {error: getIgnoredNotifyResponse(initialResponse.error, [400, 404])};
                    }

                    const initialData = initialResponse.data as IPaginatedResponse<IOfferListMapOffer>;
                    const totalCount = initialData.count;
                    const pages = Math.ceil(totalCount / OFFER_LIST_MAP_PAGE_SIZE);

                    // Prepare paginated queries
                    const pagePromises = Array.from({length: pages}, (_, index) => {
                        const pageQuery = {...params, page_size: OFFER_LIST_MAP_PAGE_SIZE, page: index + 1};
                        const pageUrl = appendQueryString(offerListMapLink, pageQuery);
                        return baseQuery({url: pageUrl});
                    });

                    const pageResponses = await Promise.all(pagePromises);

                    const errorResponse = pageResponses.find((response) => response.error);
                    if (errorResponse) {
                        return {error: getIgnoredNotifyResponse(errorResponse.error!, [400, 404])};
                    }

                    // Concatenate all offers from all pages
                    const allOffers: IOfferListMapOffer[] = [];
                    pageResponses.forEach((response) => {
                        const pageData = response.data as IPaginatedResponse<IOfferListMapOffer>;
                        allOffers.push(...pageData.results);
                    });

                    return {
                        data: {
                            offers: allOffers,
                            count: totalCount,
                            page_size: OFFER_LIST_MAP_PAGE_SIZE
                        }
                    };
                } catch {
                    return {
                        error: {
                            status: "CUSTOM_ERROR",
                            error: "Failed to fetch full map offer list"
                        }
                    };
                }
            }
        })
    })
});

export const {useGetFullMapOfferListQuery} = getMapOfferList;
